import React from 'react';

export const newsData = [
  {
    id: 1,
    title: "Crtanje i slikanje za decu i odrasle",
    subtitle: "Svake subote u našoj školi",
    icon: "fas fa-palette",
    content: (
      <>
        <p>
          <strong>Crtanje i slikanje za decu i odrasle – svake subote u našoj školi.</strong>
        </p>
        <p>
          Bez obzira na prethodno iskustvo, svi su dobrodošli da istraže boje, oblike i svoju maštu u opuštenoj i podsticajnoj atmosferi.
          Rad je u malim grupama, uz stručno vođenje.
        </p>
      </>
    ),
    summary: "Otkrijte svoju kreativnost u opuštenoj atmosferi uz stručno vođenje..."
  },
  {
    id: 2,
    title: "Časovi francuskog jezika",
    subtitle: "Za decu i odrasle",
    icon: "far fa-comments",
    content: (
      <>
        <p>
          <strong>Od sada u našoj školi možete pohađati časove francuskog jezika, kako za decu, tako i za odrasle.</strong>
        </p>
        <p>
          Programi su prilagođeni uzrastu i nivou znanja, a časovi su namenjeni i početnicima i polaznicima sa predznanjem.
        </p>
      </>
    ),
    summary: "Novi program u našoj školi! Prilagođeno početnicima i onima sa predznanjem..."
  },
  {
    id: 3,
    title: "Priprema za IELTS ispite",
    subtitle: "Test koji meri Vašu sposobnost da koristite engleski jezik",
    icon: "fa fa-book",
    content: (
      <>
        <p>
          <strong>Od sada u našoj školi možete da pohađati pripremne kurseve za oba tipa IELTS ispita - Academic i General Training.</strong>
        </p>
        <p>
         Korak po korak do željenog rezultata! Detalje o pripremnim kursevima mozete saznati u odeljku programi.
        </p>
      </>
    ),
    summary: "Pripremni kursevi za oba tipa IELTS ispita - Academic i General Training." 
  },
];
